module.exports = __webpack_public_path__ + "94f80b85f7a98e77521d6019586869c1.pdf";